module.exports = __webpack_public_path__ + "img/message-icon.aaeea8ce.svg";